/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', () => {
  const lang = (document.documentElement.lang || '').toLowerCase();
  if (!lang.startsWith('de')) return;

  const DE_TEXT = (window.languages && window.languages.productFormAddToCart) ? window.languages.productFormAddToCart : 'In den Warenkorb';
  const EN_RE = /\badd to (cart|bag|basket)\b/i;

  const setLabel = (el) => {
    if (!el) return;

    // INPUT submit/button
    if (el.tagName === 'INPUT') {
      const v = (el.value || '').trim();
      if (EN_RE.test(v)) el.value = DE_TEXT;
    } else {
      // BUTTON
      const t = (el.innerText || '').trim();
      if (EN_RE.test(t)) el.innerText = DE_TEXT;
    }

    // aria-label / title (manche Themes setzen darüber)
    const aria = el.getAttribute && el.getAttribute('aria-label');
    if (aria && EN_RE.test(aria)) el.setAttribute('aria-label', DE_TEXT);

    const title = el.getAttribute && el.getAttribute('title');
    if (title && EN_RE.test(title)) el.setAttribute('title', DE_TEXT);
  };

  // Zielgerichtet: echte Add-to-cart Controls
  const fix = (root = document) => {
    root.querySelectorAll(
      'form[action*="/cart/add"] button, form[action*="/cart/add"] input[type="submit"], form[action*="/cart/add"] input[type="button"], ' +
      'button[data-action="add-to-cart"], .ProductForm__AddToCart, .product-form__submit'
    ).forEach(setLabel);
  };

  // Debounce, damit MutationObserver nicht dauernd feuert
  let scheduled = false;
  const run = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      fix(document);
    });
  };

  // initial + nach load (einige Apps ändern erst dann)
  run();
  window.addEventListener('load', run);

  // Warehouse feuert oft Events bei Variantwechsel
  document.addEventListener('variant:changed', run);
  document.addEventListener('product:variant-change', run);

  // Beobachte DOM + Attribute (wichtig, wenn JS value/aria setzt)
  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === 'attributes') setLabel(m.target);
    }
    run();
  });

  obs.observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['value', 'aria-label', 'title']
  });
});

(function () {
  function parseProductData(scopeEl) {
    var card = scopeEl && scopeEl.closest ? (scopeEl.closest('.card') || document) : document;
    var el = card.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function requiresShipping(data, variantId) {
    if (!data || !data.product || !Array.isArray(data.product.variants)) return true;
    for (var i = 0; i < data.product.variants.length; i++) {
      var v = data.product.variants[i];
      if (String(v.id) === String(variantId)) {
        return v.requires_shipping !== false;
      }
    }
    return true;
  }

  function isBackorder(data, variantId) {
    if (!data || !data.inventories) return false;
    var inv = data.inventories[String(variantId)];
    if (!inv) return false;

    var qty = Number(inv.inventory_quantity || 0);
    var managed = !!inv.inventory_management;
    var policyContinue = inv.inventory_policy === 'continue';

    return managed && policyContinue && qty <= 0 && requiresShipping(data, variantId);
  }

  function updateWrapper(wrapper, variantId, data) {
    if (!wrapper) return;

    var preorder = wrapper.dataset.ihPreorder === 'true';
    if (!preorder) {
      wrapper.hidden = false;
      return;
    }

    wrapper.hidden = isBackorder(data, variantId);
  }

  function updateAll(scope, variantId) {
    var data = parseProductData(scope);
    if (!data) return;

    var wrappers = (scope && scope.querySelectorAll) ? scope.querySelectorAll('[data-ih-inventory-item]') : [];
    if (!wrappers || wrappers.length === 0) wrappers = document.querySelectorAll('[data-ih-inventory-item]');

    wrappers.forEach(function (w) {
      updateWrapper(w, variantId, data);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ih-inventory-item]').forEach(function (w) {
      var data = parseProductData(w);
      if (data && data.selected_variant_id) {
        updateWrapper(w, data.selected_variant_id, data);
      }
    });
  });

  // Warehouse nutzt je nach Stelle eines von beiden Events
  document.addEventListener('variant:changed', function (event) {
    if (!event || !event.detail || !event.detail.variant) return;
    updateAll(event.target || document, event.detail.variant.id);
  });

  document.addEventListener('variant:change', function (event) {
    if (!event || !event.detail || !event.detail.variant) return;
    updateAll(event.target || document, event.detail.variant.id);
  });
})();